import axios from "axios";
import {
  BLOG_LIST_REQUEST,
  BLOG_LIST_SUCCESS,
  BLOG_LIST_FAIL,
  BLOG_DETAILS_REQUEST,
  BLOG_DETAILS_SUCCESS,
  BLOG_DETAILS_FAIL,
//   BLOG_DETAILS_FAIL
} from "../constants/categoryConstants";
import { BASE_URL, BLOG_DETAIL_URL, BLOG_URL } from "../api";





export const listBlog = () => async (dispatch) => {
  try {
    dispatch({ type: BLOG_LIST_REQUEST });
    const { data } = await axios.get(BASE_URL+BLOG_URL);
    dispatch({
      type: BLOG_LIST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: BLOG_LIST_FAIL,
      payload:
        error.response && error.response.data.detail
          ? error.response.data.detail
          : error.message,
    });
  }
};


export const listBlogDetail = (id) => async (dispatch) => {
  try {
    dispatch({ type: BLOG_DETAILS_REQUEST });
    const { data } = await axios.get(BASE_URL+BLOG_DETAIL_URL+`${id}`+'/');
    dispatch({
      type: BLOG_DETAILS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: BLOG_DETAILS_FAIL,
      payload:
        error.response && error.response.data.detail
          ? error.response.data.detail
          : error.message,
    });
  }
};



export async function fetchBlogDetailAPI(id) {
  const url = `${BASE_URL}${BLOG_DETAIL_URL}${id}/`;
  // console.log('Fetching blog detail from:', url);
  const { data } = await axios.get(url);
  return data;
}